import firebase from "firebase/app";
import { db } from "../index.js";

export const signInWithGoogle = async () => {
  const provider = new firebase.auth.GoogleAuthProvider();

  try {
    const userCreds = await firebase.auth().signInWithPopup(provider);

    if (userCreds) {
      const user = userCreds.user;

      const docRef = db.collection("users").doc(user.uid);
      const followersRef = db.collection("followers").doc(user.uid);

      docRef.get().then((docSnapshot) => {
        if (!docSnapshot.exists) {
          docRef.set(
            {
              id: user.uid,
              emailAddress: user.email,
              verified: user.emailVerified,
              userName: user.displayName,
              userNameForSearch: user.displayName.toLowerCase(),
              photoUrl: user.photoURL,
              private: true,
            },
            { merge: true }
          );
        }
      });

      followersRef.get().then((docSnapshot) => {
        if (!docSnapshot.exists) {
          followersRef.set(
            { followers: [], recentActivity: [], lastActivity: "" },
            { merge: true }
          );
        }
      });

      return true;
    }
  } catch (error) {
    console.error("error signing in", error);
    return false;
  }
};
